import { PLACE_SHORT } from '../constants'
import { Stamp } from '../components/Stamp'

export function CompoundClosing() {
  return (
    <section id="contact" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="cell">
          <div className="grid lg:grid-cols-[1.2fr_auto]">
            <div className="border-b border-rule px-5 py-8 sm:px-8 lg:border-b-0 lg:border-r lg:py-10">
              <h2 className="section-title text-ink">
                Start Compound on your codebase
              </h2>
              <p className="mt-4 max-w-xl text-base leading-relaxed text-ink-muted">
                Tell us your organization, primary product line, and whether you
                want monthly or annual. Subscription covers living skills,
                support, training, and index onboarding — we answer with next
                steps, not a pitch deck.
              </p>
              <dl className="mt-8 grid gap-x-10 gap-y-4 sm:grid-cols-2">
                <div>
                  <dt className="cell-label text-ink-muted">Office</dt>
                  <dd className="mt-1.5 text-base font-medium text-ink">
                    {PLACE_SHORT}
                  </dd>
                </div>
                <div>
                  <dt className="cell-label text-ink-muted">License</dt>
                  <dd className="mt-1.5 text-base font-medium text-ink">
                    Per organization
                  </dd>
                </div>
                <div>
                  <dt className="cell-label text-ink-muted">Monthly</dt>
                  <dd className="mt-1.5 text-base font-medium text-ink">
                    USD 2,000
                  </dd>
                </div>
                <div>
                  <dt className="cell-label text-ink-muted">Annual</dt>
                  <dd className="mt-1.5 text-base font-medium text-ink">
                    USD 20,000
                  </dd>
                </div>
              </dl>
            </div>

            <div className="flex flex-col items-start justify-center px-5 py-8 sm:px-8 lg:min-w-[20rem] lg:py-10">
              <Stamp
                size="lg"
                subject="Compound subscription"
                label="Subscribe via"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
